export default {
  setUserMetrics(state, payload) {
    state.userMetrics = payload;
  },
  setResponseCode(state, payload) {
    state.responseCode = payload;
  },
};
